export default {
  getConfiguration: state => () => ({
    columns: state.columns,
    rows: state.rows,
    filters: state.filters,
    dynamicRowsEnabled: state.dynamicRowsEnabled
  }),

  getInput: state => () => {
    // We're only interested in values in existing rows
    const input = Object.keys(state.values)
      .filter(
        row => state.rows.includes(row) || state.dynamicRows.includes(row)
      )
      .reduce(
        (values, row) => ({
          ...values,
          [row]: state.values[row]
        }),
        {}
      );

    // ...and existing columns
    Object.keys(input).forEach(row => {
      input[row] = Object.keys(input[row])
        .filter(column => state.columns.includes(column))
        .reduce(
          (values, column) => ({
            ...values,
            [column]: input[row][column]
          }),
          {}
        );
    });

    return {
      dynamicRows: state.dynamicRows,
      values: input
    };
  },

  getFilters: state => column =>
    state.filters.find(filters => filters.column === column),

  /**
   * Returns translations for the provided key.
   *
   * {
   *   en_GB: 'Column A',
   *   de_DE: 'Spalte A'
   * }
   */
  getTranslations: state => key => {
    let translated = {};

    for (const language in state.translations) {
      if (state.translations[language][key]) {
        translated[language] = state.translations[language][key];
      }
    }

    return translated;
  },

  getTranslation: state => (language, key) => {
    const translations = state.translations[language] || {};
    return translations[key] || '';
  },

  getCellValue: state => (row, column) => {
    if (!state.values[row]) {
      return null;
    }

    return state.values[row][column] || null;
  }
};
